'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../../base-component.types';
import { Label } from '../../layout/Label';
import { Title } from '../../layout/Title';
import type { ListItemType } from '../List.types';

import styles from './ListItem.module.scss';

type ContainerProps = BaseComponentProps & {
  item: ListItemType;
};

function ListItem({
  style,
  className,
  item,
  testId = 'ui-list-item',
}: ContainerProps) {
  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <div className={styles['wrapper']}>
        {item.label && (
          <Label
            value={item.label.value}
            backgroundColor={item.label.backgroundColor}
          />
        )}
        <Title text={item.text} info={item.info} />
        {item.tag && <div className={styles['tag-wrapper']}>{item.tag}</div>}
      </div>
      <div className={styles['icon-wrapper']}>{item.icon}</div>
    </div>
  );
}

export { ListItem };
